import { useState, useCallback, useEffect } from "react";
import vesselService from "../services/vesselService";

export const useVessels = (autoFetch = true) => {
  const [loading, setLoading] = useState(false);
  const [vessels, setVessels] = useState([]);
  const [activeVessels, setActiveVessels] = useState([]);

  const fetchVessels = useCallback(async () => {
    setLoading(true);
    try {
      const [allRes, activeRes] = await Promise.all([
        vesselService.getAll(),
        vesselService.getActive()
      ]);
      setVessels(allRes.data || []);
      setActiveVessels(activeRes.data || []);
    } catch (err) {
      console.error("Failed to fetch vessels", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (autoFetch) fetchVessels();
  }, [autoFetch, fetchVessels]);

  return {
    loading,
    vessels,
    activeVessels,
    refreshVessels: fetchVessels
  };
};